import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
export class SafePipe implements PipeTransform {
/**
 * @param {?} _sanitizer
 */
constructor(protected _sanitizer: DomSanitizer) { }
/**
 * @param {?} value
 * @param {?=} type
 * @return {?}
 */
public transform(value: string, type: string = 'html'): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this._sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this._sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this._sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this._sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this._sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'safePipe'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DomSanitizer, },
];
}

function SafePipe_tsickle_Closure_declarations() {
/** @type {?} */
SafePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SafePipe.ctorParameters;
/** @type {?} */
SafePipe.prototype._sanitizer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
